import { render, staticRenderFns } from "./KPIProgress.vue?vue&type=template&id=482fa394&scoped=true"
import script from "./KPIProgress.vue?vue&type=script&lang=js"
export * from "./KPIProgress.vue?vue&type=script&lang=js"
import style0 from "./KPIProgress.vue?vue&type=style&index=0&id=482fa394&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482fa394",
  null
  
)

export default component.exports